// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2899":"3d3ed636","8405":"31420fc2"}[chunkId] + ".chunk.css";
};